import { LogoMark } from "@/components/brand/logo-mark";

/**
 * Landing mark — Agency Atelier LogoMark (teal R), not the old mint pipeline glyph.
 * `idSuffix` keeps SVG gradient ids unique when navbar + footer both render.
 */
export function Logo({
  size = 24,
  idSuffix = "",
}: {
  size?: number;
  idSuffix?: string;
}) {
  return <LogoMark size={size} idSuffix={idSuffix} />;
}
